import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom'
import { verifyCode } from '../../actions/auth/verifyCode';
import Swal from 'sweetalert2';
import { useTranslation, Trans } from 'react-i18next';

const lngs = {
    en: { nativeName: 'English' },
    tr: { nativeName: 'Türkçe' },
    si: { nativeName: 'Slovenski jezik' }
};

function VerifyCode(props) {
    const { t, i18n } = useTranslation();
    const [mounted, setMounted] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [code, setCode] = useState("");

    function handleSubmit(event) {
        event.preventDefault();
        dispatch(verifyCode(code))
    }

    useEffect(() => {
        if (mounted && props.verifyCode.done === false) {
            if (Object.keys(props.verifyCode.error).length !== 0) {
                const status = props.verifyCode.error.response?.status;
    
                if (status === 403) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Doğrulama kodu hatalı',
                        text: "Lütfen doğrulama kodunuzu kontrol ediniz.",
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    });
                } else if (status === 429) {
                    Swal.fire({
                        icon: "error",
                        title: "Erişim Kısıtlandı",
                        text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
                        footer: `
                          <div>
                            <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
                            <br>
                            <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
                            <br>
                            <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
                          </div>
                        `,
                      });                      
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: "Beklenmedik bir hata oluştu lütfen tekrar deneyiniz.",
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    });
                }
            }
        }
        if (props.verifyCode.done) {
            navigate("/register");
        }
        setMounted(true);
    }, [props.verifyCode, mounted, navigate]);
    

    return (
        <div className="">
            <div><img className='img-fluid mt-10 ms-10 hidden md:block' src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png" width={150} alt="" /></div>
            <main className="w-full max-w-md mx-auto p-6 flex justify-center">
                <div className="mt-0 bg-white border border-gray-200 rounded-xl shadow-sm dark:bg-gray-800 dark:border-gray-700 ">
                    <div className="p-4 sm:p-14 ">
                        <div className="text-center">
                            <h1 className="block text-2xl font-bold text-gray-800 dark:text-white">Telefon Doğrulama</h1>
                            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                                Lütfen telefonunuza gelen doğrulama kodunu giriniz.
                            </p>
                        </div>
                        <div className="mt-5">
                            <form onSubmit={handleSubmit}>
                                <div className="grid gap-y-4">
                                    <div>
                                        <div className="flex justify-between items-center">
                                            <label htmlFor="password" className="block text-sm mb-2 dark:text-white">Doğrulama Kodu</label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                required
                                                type="text"
                                                className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                placeholder={t('Password')}
                                                onChange={(e) => { setCode(e.target.value) }}
                                                value={code}
                                                id="code"
                                                aria-describedby="basic-addon3" />
                                            <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <p className="hidden text-xs text-red-600 mt-2" id="password-error">8+ characters required</p>
                                    </div>
                                    {props.verifyCode.spinner ?
                                        <button type="button" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">
                                            <span className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full" role="status" aria-label="loading"></span>
                                            İşlem devam ediyor
                                        </button>
                                        :
                                        <button type="submit" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">Devam et</button>

                                    }

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(VerifyCode);
